<template>
  <main-layout>
    <template slot="header-title">{{ $t('contest.singular') }}</template>

    <template slot="main">
      <div class="container mx-auto">
        <div v-if="contests.length > 0" class="contest-list">
          <contest-card v-for="contest in contests" :key="contest.id" :id="contest.id"></contest-card>
          <div class="add-contest" @click="isContestFormOpened = true">
            <font-awesome-icon icon="plus"></font-awesome-icon><span>contest</span>
          </div>
        </div>
        <div v-if="contests.length === 0">
          <empty :title="$t('contest.empty.title')" :message="$t('contest.empty.message')">
            <a @click="isContestFormOpened = true">{{ $t('contest.actions.create') }}</a>
          </empty>
          <form-contest v-if="isContestFormOpened" @close="isContestFormOpened = false"></form-contest>
        </div>
        <form-contest
          v-if="isContestFormOpened"
          :open="isContestFormOpened"
          @close="hideFormContest"
          :contest="contestEditing"></form-contest>
      </div>
    </template>
  </main-layout>
</template>

<script>

import FormContest from '@/components/contests/contest-form.vue'
import Empty from '@/components/box-entity-empty.vue'
import { mapGetters, mapActions } from 'vuex'
import ContestCard from '@/components/contests/contest-card.vue'

export default {
  components: { FormContest, ContestCard, Empty },
  data () {
    return {
      isContestFormOpened: false,
      contestOpenedMoreAction: null,
      contestEditing: null
    }
  },
  computed: {
    ...mapGetters('contest', {
      contests: 'contests'
    }),
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },
  watch: {
    site: {
      handler: 'initContestList',
      immediate: true
    }
  },
  methods: {

    ...mapActions('contest',
      ['loadContests', 'addContest', 'removeContest']),

    editContest (contest) {
      this.contestEditing = contest
      this.isContestFormOpened = true
    },
    hideFormContest () {
      this.isContestFormOpened = false
      this.contestEditing = null
    },

    initContestList () {
      if (this.site) {
        this.loadContests(this.site.sitekey)
          .then((result) => {
            setTimeout(() => {
              this.isAllContestLoaded = true
            }, 1000)
          }).catch((result) => {
            setTimeout(() => {
              this.isAllContestLoaded = true
            }, 1000)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.contest-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, auto));
    grid-gap: 24px;
    > .box {
        padding:20px;
        > header {
            display: grid;
            grid-template-columns: 1fr 20px;

            .group-actions {
                float: right;
                height: 24px;
            }
        }
    }

    .contest.box {
        cursor: pointer;
    }
}

.add-contest {
    border: 1px dashed #aaa;
    background: #fefefe;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    cursor: pointer;

    > span {
        margin: 8px;
    }

    &:hover {
        background: #fafafa;
        > span {
            text-decoration: underline;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contest/ContestList.vue